// -------------------------------------------- IMPORT FILES START --------------------------------------------------------------
// ## Import Files
import $api from "../Api.js";
import ResponseChecker from "../Middlewares/ResponseChecker.js";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints/index.js";

// -------------------------------------------- IMPORT FILES ENDED --------------------------------------------------------------

/*
 request.map of ProjectMainProject
  GetAll,
  Create,
  GetById,
  Update,
  Delete
*/

// ## ProjectMainProject Get
/**
 *
 * @param {{params: object, query: { page: number, limit: number, search: string }}} option
 *
 * @returns
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.ProjectMainProject.GetAll(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};
// ## ProjectMainProject Create
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 *
 * @returns
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.ProjectMainProject.Create(), form);
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProjectMainProject Get ById
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.ProjectMainProject.GetById(option));
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProjectMainProject Update
/**
 *
 * @param {{ "key": "string", value: "string" }} form
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Update = async (form, option) => {
  const response = await $api.put(
    Endpoints.ProjectMainProject.Update(option),
    form
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

// ## ProjectMainProject Delete
/**
 *
 * @param {{params: { id: string }, query: object}} option
 
 * @returns
 */
export const Delete = async (option) => {
  const response = await $api.delete(
    Endpoints.ProjectMainProject.Delete(option)
  );
  const checker = await ResponseChecker(defaultMessages, response);
  return checker;
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
